(function() {

    'use strict';

    var CookiesCmp = {
        bindings: {
            onCloseBanner:'&'
        },
        controller: CookiesCmpCtrl,
        templateUrl: 'cookies.component.html'
    };

    CookiesCmpCtrl.$inject = [
        'ItxStaticResourceSvc',
        '$timeout'
    ];

    function CookiesCmpCtrl(
        ItxStaticResourceSvc,
        $timeout
    ) {

        var _this = this;
        _this.showCookies = false;

        _this.$onInit = function(){
            _this.banner='cookies';
        };

        _this.closeCookiesWarn = function() {
            inditex.closeCookiesWarn();
            _this.onCloseBanner({banner: _this.banner, hideBannerNextTime: true });
        };

        inditex.onReady(function () {
            _this.cookiePolicyHref = ItxStaticResourceSvc.getCookiePolicyPath();
            $timeout(_initCookies, 2000);
        });

        function _initCookies() {
            _this.showCookies = true;
            inditex._doTestCookiesPolicy();
        }

    }

    angular.module('itxApp.common')
        .component('itxCookies', CookiesCmp);
    
})();